import { Mic, ListChecks, Share2 } from "lucide-react";
import { useApp } from "@/lib/i18n";

const ITEMS = [
  [1, Mic, ["Rakam di mana-mana mesyuarat", "Record any meeting"], ["Bersemuka, di telefon atau dalam Zoom, Meet & Teams. MinitAI faham campuran Bahasa Melayu dan English, serta kenal setiap penutur.", "In person, on your phone or in Zoom, Meet & Teams. MinitAI understands mixed Malay and English and recognises every speaker."]],
  [2, ListChecks, ["Minit rasmi siap dalam minit", "Official minutes in minutes"], ["Minit Rasmi format Malaysia, Nota Kuliah, Laporan atau Temubual: lengkap dengan keputusan dan tindakan, sedia untuk disemak dan disunting.", "Malaysian-format official minutes, lecture notes, reports or interviews, complete with decisions and actions, ready to review and edit."]],
  [3, Share2, ["Eksport & kongsi sekali klik", "Export & share in one click"], ["Muat turun PDF, Word, PowerPoint atau CSV, atau kongsi terus melalui WhatsApp, emel dan pautan dengan pasukan anda.", "Download as PDF, Word, PowerPoint or CSV, or share straight to your team via WhatsApp, email or link."]],
];

export const UspShowcase = () => {
  const { L } = useApp();
  return (
    <section className="mx-auto max-w-7xl px-4 py-20 sm:px-6 sm:py-24 lg:px-8" data-testid="usp-section">
      <p className="text-sm font-semibold uppercase tracking-wider text-violet-700">{L("Kenapa MinitAI", "Why MinitAI")}</p>
      <h2 className="mt-3 max-w-2xl text-3xl font-extrabold tracking-tight sm:text-4xl">{L("Dari perbualan ke minit rasmi, tanpa menaip sepatah pun.", "From conversation to official minutes, without typing a word.")}</h2>
      <div className="mt-12 grid gap-6 md:grid-cols-3">
        {ITEMS.map(([n, Icon, title, desc], i) => (
          <article key={n} className="group overflow-hidden rounded-3xl border border-slate-200 bg-white shadow-sm transition-[transform,box-shadow] duration-300 hover:-translate-y-1 hover:shadow-lg" style={{ animationDelay: `${i * 120}ms` }} data-testid={`usp-card-${n}`}>
            <div className="aspect-[600/520] overflow-hidden bg-[#F7EDE2]">
              <img src={`/landing/usp-${n}.webp`} alt={L(...title)} loading="lazy" className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-[1.03]" />
            </div>
            <div className="p-6">
              <div className="flex items-center gap-3">
                <span className="grid h-9 w-9 place-items-center rounded-xl bg-violet-600 text-white"><Icon size={18} /></span>
                <span className="font-mono text-xs font-bold text-violet-400">0{n}</span>
              </div>
              <h3 className="mt-4 text-lg font-bold text-slate-900">{L(...title)}</h3>
              <p className="mt-2 text-sm leading-relaxed text-slate-600">{L(...desc)}</p>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
};
